import { useResponsive } from '../../../hooks/useResponsive';
import HeroDesktop from './HeroDesktop';
import HeroMobile from './HeroMobile';
import { useHero } from './useHero';

const Hero = () => {
  const breakpointIndex = useResponsive([768]);
  const props = useHero();

  if (breakpointIndex === 0) {
    return <HeroMobile {...props} />;
  }
  return <HeroDesktop {...props} />;
};

export default Hero;
